// SEO utility functions for dynamic page titles and meta descriptions

interface SEOData {
  title: string;
  description: string;
  keywords?: string;
}

export const pagesSEO: Record<string, SEOData> = {
  '/': {
    title: 'HDF Hauling - Professional Trucking Fleet Management & Dispatch Services',
    description: 'HDF Hauling provides expert trucking fleet management, dispatch services, and reliable freight hauling across the country. Partner with us to maximize your trucking business efficiency and profitability.',
    keywords: 'trucking, fleet management, dispatch services, freight hauling, logistics, CDL training, trucking business startup'
  },
  '/services': {
    title: 'Hauling Services - Hotshot, Equipment & Vehicle Transport | HDF Hauling',
    description: 'HDF Hauling delivers reliable hotshot freight, equipment, vehicle, and livestock hauling across local and long-distance routes—plus dispatch and startup support for trucking businesses.',
    keywords: 'hauling services, hotshot hauling, equipment transport, car hauling, vehicle transport, flatbed hauling, freight delivery, dispatch services, trucking business startup'
  },
  '/rentals': {
    title: 'Trailer Rentals - Hotshot & Gooseneck Trailers | HDF Hauling',
    description: 'Rent quality trailers from HDF Hauling. Browse our gooseneck, bumper pull, and flatbed trailers available for hotshot and freight hauling. Contact us for a rental quote today.',
    keywords: 'trailer rentals, hotshot trailer rental, gooseneck trailer, bumper pull trailer, flatbed rental, trailer rental quote'
  },
  '/privacy': {
    title: 'Privacy Policy | HDF Hauling',
    description: 'Learn about HDF Hauling\'s privacy policy and how we protect your personal information when using our trucking and fleet management services.',
    keywords: 'privacy policy, data protection, trucking services privacy'
  }
};

export const updatePageSEO = (pathname: string) => {
  const seoData = pagesSEO[pathname] || pagesSEO['/'];
  
  // Update document title
  document.title = seoData.title;
  
  // Update meta description
  let metaDescription = document.querySelector('meta[name="description"]');
  if (metaDescription) {
    metaDescription.setAttribute('content', seoData.description);
  } else {
    metaDescription = document.createElement('meta');
    metaDescription.setAttribute('name', 'description');
    metaDescription.setAttribute('content', seoData.description);
    document.head.appendChild(metaDescription);
  }
  
  // Update meta keywords if provided
  if (seoData.keywords) {
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', seoData.keywords);
    } else {
      metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      metaKeywords.setAttribute('content', seoData.keywords);
      document.head.appendChild(metaKeywords);
    }
  }
  
  // Update Open Graph tags
  updateOpenGraphTags(seoData);
};

const updateOpenGraphTags = (seoData: SEOData) => {
  const ogTitle = document.querySelector('meta[property="og:title"]');
  const ogDescription = document.querySelector('meta[property="og:description"]');
  const twitterTitle = document.querySelector('meta[property="twitter:title"]');
  const twitterDescription = document.querySelector('meta[property="twitter:description"]');
  
  if (ogTitle) ogTitle.setAttribute('content', seoData.title);
  if (ogDescription) ogDescription.setAttribute('content', seoData.description);
  if (twitterTitle) twitterTitle.setAttribute('content', seoData.title);
  if (twitterDescription) twitterDescription.setAttribute('content', seoData.description);
};